angular.module('lead')
    .component('leadDashboard', {
        bindings: {
        },
        templateUrl: 'app/lead/dashboard/dashboard.html',
        controller: function ($scope, LeaveService, Principal, $http) {
            this.LeaveService = LeaveService

            this.$onInit = () => {
                this.refreshPermissionsAndData()
                this.unwatchAuthenticationChanged = $scope.$on('authenticationChanged', () => this.refreshPermissionsAndData())
            }

            this.$onDestroy = () => {
                if (angular.isFunction(this.unwatchAuthenticationChanged)) {
                    this.unwatchAuthenticationChanged()
                }
            }

            this.refreshPermissionsAndData = () => {
                Principal.hasAnyAuthorityPromise(["ROLE_LEADS"]).then(hasAccess => {
                    this.isManager = hasAccess
                    this.isUser = hasAccess
                    if (hasAccess) {
                        this.loadStatistics()
                    } else {
                        this.data = null
                    }
                })
            }

            this.loadStatistics = () => {
                return $http.get('/crm/api/lead/user-statistics').then(response => {
                    this.data = response.data;
                }).catch(() => {
                    this.data = null
                });
            }

            this.managerLeadFilters = (item, statuses) => {
                const filters = {status: statuses}
                if (item && item.user && item.user.id) {
                    filters.manager = item.user.id
                } else {
                    filters.managerMissing = true
                }
                return filters
            }
        }
    })
    .component('leadAdvisorSummaryDashboard', {
        bindings: {
        },
        templateUrl: 'app/lead/dashboard/advisor-summary-dashboard.html',
        controller: function ($scope, Principal, $http) {
            this.items = []

            this.$onInit = () => {
                this.refreshPermissionsAndData()
                this.unwatchAuthenticationChanged = $scope.$on('authenticationChanged', () => this.refreshPermissionsAndData())
            }

            this.$onDestroy = () => {
                if (angular.isFunction(this.unwatchAuthenticationChanged)) {
                    this.unwatchAuthenticationChanged()
                }
            }

            this.refreshPermissionsAndData = () => {
                Principal.hasAnyAuthorityPromise(["ROLE_LEADS"]).then(hasAccess => {
                    this.isManager = hasAccess
                    if (hasAccess) {
                        this.loadStatistics()
                    } else {
                        this.items = []
                    }
                })
            }

            this.loadStatistics = () => {
                return $http.get('/crm/api/lead/user-statistics').then(response => {
                    this.items = this.buildAdvisorStatistics(response.data && response.data.advisorSummaryStatistics)
                }).catch(() => {
                    this.items = []
                });
            }

            this.buildAdvisorStatistics = items => {
                let overdueNextContactEnd = moment().format('YYYY-MM-DD')

                if (!items || !items.length) {
                    return []
                }

                return items
                    .filter(item => item && item.user && item.user.id)
                    .map(item => ({
                        user: item.user,
                        totalWait: item.totalWait || 0,
                        overdueCount: item.overdueCount || 0,
                        waitFilters: {
                            manager: item.user.id,
                            status: ['WAIT']
                        },
                        overdueFilters: {
                            manager: item.user.id,
                            status: ['ERROR', 'WAIT', 'START', 'PROSPECT', 'IN', 'RESERVED', 'CONTRACT', 'NOD', 'OUT'],
                            nextContactDateEnd: overdueNextContactEnd
                        }
                    }))
                    .filter(item => item.totalWait > 0 || item.overdueCount > 0)
                    .sort((a, b) => (a.user.fullName || '').localeCompare(b.user.fullName || ''))
            }
        }
    })
    .component('leadTimelineDashboard', {
        bindings: {
        },
        templateUrl: 'app/lead/dashboard/timeline-dashboard.html',
        controller: function ($scope, Principal, $http) {
            this.timeline = []
            this.managers = []
            this.selectedManager = null
            this.selectedProjects = []
            this.activePopoverItem = null

            this.$onInit = () => {
                this.refreshPermissionsAndData()
                this.unwatchAuthenticationChanged = $scope.$on('authenticationChanged', () => this.refreshPermissionsAndData())
            }

            this.$onDestroy = () => {
                if (angular.isFunction(this.unwatchAuthenticationChanged)) {
                    this.unwatchAuthenticationChanged()
                }
            }

            this.refreshPermissionsAndData = () => {
                Principal.hasAnyAuthorityPromise(["ROLE_LEADS"]).then(hasAccess => {
                    this.isManager = hasAccess
                    if (hasAccess) {
                        this.loadStatistics()
                    } else {
                        this.timeline = []
                        this.managers = []
                        this.selectedProjects = []
                    }
                })
            }

            this.loadStatistics = () => {
                let params = this.dashboardParams()
                return $http.get('/crm/api/lead/user-statistics', {params}).then(response => {
                    this.managers = this.extractManagers(response.data && response.data.timelineManagers)
                    this.timeline = this.buildTimeline(response.data && response.data.timelineStatistics)
                }).catch(() => {
                    this.timeline = []
                    this.managers = []
                });
            }

            this.dashboardParams = () => {
                let params = {}
                let projectIds = this.selectedProjectIds()
                if (this.selectedManager) {
                    params.managerId = this.selectedManager.id
                }
                if (projectIds.length) {
                    params.projectIds = projectIds
                }
                return params
            }

            this.selectedProjectIds = () => this.projectIds(this.selectedProjects)

            this.projectIds = projects => {
                if (!angular.isArray(projects)) {
                    projects = projects == null ? [] : [projects]
                }
                return projects
                    .map(project => angular.isObject(project) ? project.id : project)
                    .filter(projectId => projectId != null && projectId !== '')
            }

            this.timelineFilters = item => {
                let params = {
                    periodStart: item.month + '-01',
                    periodEnd: moment(item.month + '-01').endOf('month').format('YYYY-MM-DD'),
                    status: ['WAIT', 'START', 'PROSPECT', 'IN', 'RESERVED', 'CONTRACT', 'NOD', 'OUT'],
                    filter: 'all',
                    customFilter: 'exclude-duplicate-out',
                    page: null
                }
                let projectIds = this.selectedProjectIds()
                if (this.selectedManager) {
                    params.manager = this.selectedManager.id
                }
                if (projectIds.length) {
                    params.project = projectIds
                }
                return params
            }

            this.extractManagers = items => {
                if (!items || !items.length) {
                    return []
                }

                return items
                    .filter(item => item && item.id)
                    .sort((a, b) => (a.fullName || '').localeCompare(b.fullName || ''))
            }

            this.onManagerFilterChanged = () => this.loadStatistics()
            this.onProjectFilterChanged = selected => {
                if (angular.isArray(selected)) {
                    this.selectedProjects = selected
                }
                return this.loadStatistics()
            }

            this.buildTimeline = items => {
                if (!items || !items.length) {
                    return []
                }

                let max = Math.max.apply(null, items.map(item =>
                    (item.waitCount || 0)
                    + (item.startCount || 0)
                    + (item.prospectCount || 0)
                    + (item.inCount || 0)
                    + (item.reservedCount || 0)
                    + (item.contractCount || 0)
                    + (item.nodCount || 0)
                    + (item.outCount || 0)
                )) || 1

                return items.map(item => {
                    let waitCount = item.waitCount || 0
                    let startCount = item.startCount || 0
                    let prospectCount = item.prospectCount || 0
                    let inCount = item.inCount || 0
                    let reservedCount = item.reservedCount || 0
                    let contractCount = item.contractCount || 0
                    let nodCount = item.nodCount || 0
                    let outCount = item.outCount || 0
                    let total = waitCount + startCount + prospectCount + inCount + reservedCount + contractCount + nodCount + outCount

                    return {
                        month: item.month,
                        label: item.label,
                        waitCount: waitCount,
                        startCount: startCount,
                        prospectCount: prospectCount,
                        inCount: inCount,
                        reservedCount: reservedCount,
                        contractCount: contractCount,
                        nodCount: nodCount,
                        outCount: outCount,
                        total: total,
                        inConversion: total ? ((inCount / total) * 100).toFixed(2) : '0.00',
                        contractConversion: total ? ((contractCount / total) * 100).toFixed(2) : '0.00',
                        totalHeight: Math.max((total / max) * 100, total ? 8 : 0),
                        waitShare: total ? (waitCount / total) * 100 : 0,
                        startShare: total ? (startCount / total) * 100 : 0,
                        prospectShare: total ? (prospectCount / total) * 100 : 0,
                        inShare: total ? (inCount / total) * 100 : 0,
                        reservedShare: total ? (reservedCount / total) * 100 : 0,
                        contractShare: total ? (contractCount / total) * 100 : 0,
                        nodShare: total ? (nodCount / total) * 100 : 0,
                        outShare: total ? (outCount / total) * 100 : 0
                    }
                })
            }
        }
    })
